import ICON_REQUEST from '@/assets/sideBar/request.png';
import ICON_X_BOLD from '@/assets/sideBar/x_bold.png';
import styled from 'styled-components';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks';
import { closeCsModal, updateCs } from '@/store/modules/cs';
import useGetCsMessage from '@/hooks/useGetCsMessageAlert';
import CsModal from '@/components/sideNavigation/Cs/CsModal';
import GuideModal from '@/components/sideNavigation/Cs/GuideModal';

function Cs() {
  const dispatch = useAppDispatch();
  const { hasTotalCount, total1on1Count, totalProcessedCount } =
    useGetCsMessage();
  const { isOpenCsModal } = useAppSelector((state) => state.cs);

  const onToggle = () => {
    if (isOpenCsModal) {
      dispatch(closeCsModal());
    } else if (total1on1Count > 0) {
      dispatch(
        updateCs({
          isOpenCsModal: true,
          activeTab: 'CHAT',
        }),
      );
    } else if (totalProcessedCount > 0) {
      dispatch(
        updateCs({
          isOpenCsModal: true,
          activeTab: 'RESULT',
        }),
      );
    } else {
      dispatch(
        updateCs({
          isOpenCsModal: true,
        }),
      );
    }
  };

  return (
    <Wrapper>
      {/* CS 모달 toggle 버튼 */}
      <RequestButton onClick={onToggle}>
        <img
          src={isOpenCsModal ? ICON_X_BOLD : ICON_REQUEST}
          alt='소모품 요청'
          width={isOpenCsModal ? 20 : 36}
        />
        {hasTotalCount && <Count>{total1on1Count + totalProcessedCount}</Count>}
      </RequestButton>

      {/* 알림 모달 */}
      <GuideModal />

      {/* CS 모달 */}
      <CsModal isOpen={isOpenCsModal} />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  width: 64px;
  height: 64px;
`;

const RequestButton = styled.button`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 26px;
  border: 1px solid #246cf6;
  background: #fff;
  box-shadow: 0px 0px 20px 1px rgba(0, 49, 144, 0.8);
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 410;
`;

const Count = styled.span`
  position: absolute;
  top: -4px;
  left: 46px;
  min-width: 21px;
  height: 21px;
  padding: 0 7px;
  border: 1px solid #fff;
  font-weight: 800;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: -2%;
  color: #fff;
  background-color: #ff2d55;
  border-radius: 100px;
  text-align: left;
`;

export default Cs;
